// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VLzpKc9CGljMsdoUlRXN{height:40px;min-width:130px;font-weight:bold;font-size:13px !important;color:var(--color-main)}`, "",{"version":3,"sources":["webpack://./src/components/listings/DefaultSortItemsMenu/styles.module.sass"],"names":[],"mappings":"AAAA,sBACE,WAAA,CACA,eAAA,CACA,gBAAA,CACA,yBAAA,CACA,uBAAA","sourcesContent":[".menuButton\n  height: 40px\n  min-width: 130px\n  font-weight: bold\n  font-size: 13px !important\n  color: var(--color-main)\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuButton": `VLzpKc9CGljMsdoUlRXN`
};
export default ___CSS_LOADER_EXPORT___;
